module.exports = "https://cdn.dove.it/_next/static/public/assets/services/consulenti_430.94a54d3cb5489059f5d1b6b13265d0db.jpg";